// ** Modules
import React from 'react';

// ** UI
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

// ** Components
import UserDropdown from './appBarElements/UserDropdown';
// import Autocomplete from '@/components/Autocomplete';
// import ThemeSwitcher from '@/components/ThemeSwitcher';
import HeaderLoginSignUp from './appBarElements/HeaderLogin';
// import LanguageSwitcher from '@/components/LanguageSwitcher';
// import ShortcutsDropdown from './appBarElements/ShortcutsDropdown';
// import NotificationDropdown from './appBarElements/NotificationDropdown';
import { Icon } from '@/components/common/icons';

// ** Types
import type { User } from 'next-auth';
import type { AppContext } from '@/types/contextTypes';
import type { LayoutProps } from '@/types/layoutProps';
import type { getProviders } from 'next-auth/react';

// Represents the full object returned by getProviders() (Record<string, ClientSafeProvider>)
export type ProvidersMap = Awaited<ReturnType<typeof getProviders>>;

// Represents an individual ClientSafeProvider object
export type ClientSafeProvider = NonNullable<ProvidersMap>[string];

type VaerticalAppBarContentProps = {
	hidden: LayoutProps['hidden'];
	toggleNavVisibility: () => void;
	settings: LayoutProps['settings'];
	saveSettings: LayoutProps['saveSettings'];
	currentUser: User;
	locale: AppContext['locale'];
	providers?: ProvidersMap | Record<string, ClientSafeProvider> | null;
	host?: AppContext['host'];
};

// const notifications: NotificationsType[] = [
// 	{
// 		meta: 'Jetzt',
// 		title: 'Neues Protokoll verfügbar',
// 		subtitle: 'Mitgliederversammlung vom 15.6.2024',
// 		avatarIcon: <Icon icon="mdi-folder" /> // Add avatarIcon
// 	},
// 	{
// 		meta: 'Gestern',
// 		title: 'Ausschuss Berufsbildung',
// 		subtitle: 'Einladung zur Ausschusssitzung',
// 		avatarIcon: <Icon icon="mdi-calendar-blank-outline" /> // Add avatarIcon
// 	},
// 	{
// 		meta: '12.05.24',
// 		title: 'Beratungsbericht aktualisiert',
// 		subtitle: 'Maschinenbewertung',
// 		avatarIcon: <Icon icon="mdi-comment-processing-outline" /> // Add avatarIcon
// 	},
// 	{
// 		meta: '01.12.23',
// 		title: 'Ihr Profil wurde aktiviert',
// 		subtitle: 'Zugriff auf Ihr Dashboard',
// 		avatarIcon: <Icon icon="mdi-account" /> // Add avatarIcon
// 	}
// ];

// const shortcuts: ShortcutsType[] = [
// 	{
// 		title: 'Calendar',
// 		url: '/apps/calendar',
// 		subtitle: 'Appointments',
// 		icon: 'mdi:calendar-month-outline'
// 	},
// 	{
// 		title: 'Invoice App',
// 		url: '/apps/invoice/list',
// 		subtitle: 'Manage Accounts',
// 		icon: 'mdi:receipt-text-outline'
// 	},
// 	{
// 		title: 'Users',
// 		url: '/apps/user/list',
// 		subtitle: 'Manage Users',
// 		icon: 'mdi:account-outline'
// 	},
// 	{
// 		url: '/apps/roles',
// 		title: 'Role Management',
// 		subtitle: 'Permissions',
// 		icon: 'mdi:shield-check-outline'
// 	},
// 	{
// 		url: '/',
// 		title: 'Dashboard',
// 		icon: 'mdi:chart-pie',
// 		subtitle: 'User Dashboard'
// 	},
// 	{
// 		title: 'Settings',
// 		icon: 'mdi:cog-outline',
// 		subtitle: 'Account Settings',
// 		url: '/pages/account-settings/account'
// 	},
// 	{
// 		title: 'Help Center',
// 		subtitle: 'FAQs & Articles',
// 		icon: 'mdi:help-circle-outline',
// 		url: '/pages/help-center'
// 	},
// 	{
// 		title: 'Dialogs',
// 		subtitle: 'Useful Dialogs',
// 		icon: 'mdi:window-maximize',
// 		url: '/pages/dialog-examples'
// 	}
// ];

const VerticalAppBarContent = ({
	hidden,
	settings,
	// saveSettings,
	toggleNavVisibility,
	currentUser,
	// locale,
	providers
}: VaerticalAppBarContentProps) => {
	// Translation
	// const { t } = useTranslation();

	// const navItemCss = {
	// 	display: 'flex',
	// 	justifyContent: 'center',
	// 	minWidth: '64px',
	// 	padding: '6px 8px',
	// 	fontSize: '1rem'
	// };

	return (
		<Box
			sx={{
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between'
			}}
		>
			<Box sx={{ mr: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
				{hidden && !settings.navHidden ? (
					<IconButton color="inherit" sx={{ ml: -2.75 }} onClick={toggleNavVisibility}>
						<Icon name="mdi:menu" />
					</IconButton>
				) : null}

				{/* Search */}
				{/* <Autocomplete hidden={hidden} settings={settings} /> */}

				{/* <Grid
					container
					item
					direction="row"
					alignItems="center"
					spacing={4}
					justifyContent="center"
					wrap="nowrap"
				>
					<Grid>
						<Link href="/shop" color="inherit" sx={navItemCss}>
							Veranstaltungen
						</Link>
					</Grid>
				</Grid> */}
			</Box>

			<Box sx={{ display: 'flex', alignItems: 'center', gap: 5 }}>
				{/* <LanguageSwitcher
					settings={settings}
					saveSettings={saveSettings}
					locale={locale}
				/>

				<ThemeSwitcher settings={settings} saveSettings={saveSettings} /> */}

				{!currentUser && (
					<HeaderLoginSignUp
						// productData={productData}
						// settings={settings}
						// saveSettings={saveSettings}
						// locale={locale}
						providers={providers}
					/>
				)}

				{currentUser && (
					<React.Fragment>
						{/* <ShortcutsDropdown settings={settings} shortcuts={shortcuts} /> */}
						{/* <NotificationDropdown
							settings={settings}
							notifications={notifications}
						/> */}
						<UserDropdown currentUser={currentUser} />
					</React.Fragment>
				)}
			</Box>
		</Box>
	);
};

export default VerticalAppBarContent;
